var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isImportExportEnabled)?_c('el-upload',{ref:"upload",staticClass:"upload-btn",attrs:{"action":"#","accept":_vm.accepts,"limit":1,"http-request":_vm.handleUpload,"show-file-list":false}},[_c('i',{staticClass:"xp-icon-download"}),_vm._v("\n  "+_vm._s(_vm.$t('CampaignForm_Button_ImportContent'))+"\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5b5f652","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/campaign-manage/components/ImportContentButton.vue
// module id = null
// module chunks = 